module.exports = __webpack_public_path__ + "static/media/1.81c648b1.svg";